// eslint-disable-next-line
export const passportSeriesRegex = /\d{4}\s\d{6}/gi;
export const passportCodeRegex = /^\d{3}-\d{3}$/gi;

export const validatePhone = (phone) => {
  if (!phone) {
    return false;
  }

  const digits = phone.replace(/\D/g, '');

  if (digits.length !== 11) {
    return false;
  }

  const trimmedPhone = phone.replace(/\s/g, '');

  return /^\+?[\d-]+$/.test(trimmedPhone) || /^\+?\d*\(\d+\)[\d-]+$/.test(trimmedPhone);
};
